import React from 'react'
import { Translate } from '../language'
import audioImg from '../img/ic_audio.png'
import { ReactComponent as CloseIcon } from '../img/ic_cerrar.svg'
import { AudioIcon } from '../assets/icons';
const audioType = 'audio/mp4';

class ModalTagFriend extends React.Component {

    state = {
        initialTime: 0,
        recording: false,
        audio: ''
    }


    stopRecording(e) {
        e.preventDefault()
        if (this.mediaRecorder !== undefined)
            if (this.mediaRecorder.state === 'recording') {
                this.mediaRecorder.stop()
                this.mediaRecorder.stream.getAudioTracks().forEach(function (track) { track.stop(); });
                this.setState({ recording: false })
                clearTimeout(this.time)
                this.saveAudio()
                clearInterval(this.state.interval)
            }
    }

    async startRecording(e) {
        e.preventDefault()
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        console.log()
        this.time = ''
        this.audio.play();
        this.mediaRecorder = new MediaRecorder(stream);
        this.chunks = [];
        this.mediaRecorder.ondataavailable = e => {
            if (e.data && e.data.size > 0) {
                this.chunks.push(e.data);
            }
        }
        var elem = document.getElementsByName("myBar")
        this.setState({ audio: '' })
        this.setState({ initialTime: 0 })
        this.setState({
            interval: setInterval(() => {
                this.setState({ initialTime: this.state.initialTime + 1 })
                var widthProgressBar = ((this.state.initialTime * 92) / 60) + 8
                elem[0].style.width = widthProgressBar + '%';
            }, 1000)
        })

        this.chunks = [];
        // start recorder with 10ms buffer
        this.mediaRecorder.start(3);
        // say that we're recording
        this.setState({ recording: true });
        this.time = setTimeout(() => {
            this.stopRecording(e)
        }, 60001);
        e.persist()
    }

    saveAudio() {
        const blob = new Blob(this.chunks, { type: audioType })
        const audioURL = window.URL.createObjectURL(blob)
        const nameFile = Date.now()+".mp4"
        const fileData = new File(this.chunks, nameFile, { type: audioType })
        fileData.url = { audioURL }
        this.setState({ audio: audioURL })
        this.setState({ fileAudio: fileData })
    }

    sendAudioToPost(e) {
        e.stopPropagation()
        this.props.setData({ [this.state.fileAudio.name]: { type: this.state.fileAudio.type, name: this.state.fileAudio.name, url: this.state.audio, file: this.state.fileAudio } })
        this.props.setOnlyAudio(true)
        this.setState({ audio: '' })
        this.props.closeModal(e)
        console.log()
    }

    render() {
        const { recording, audio, initialTime } = this.state;

        const divStyle = {
            display: this.props.displayModal ? 'block' : 'none'
        }

        const close = (e) => {
            e.stopPropagation()
            this.stopRecording(e)
            this.props.closeModal(e)
        }

        if (this.props.displayModal) {

            return (
                <div
                    className={"modal modal-tag-friend"}
                    onClick={close}
                    style={divStyle} >
                    <div
                        className="modal-content modal-content-tag-friend"
                        onClick={e => e.stopPropagation()} >
                        <div onClick={close} className="close-modal">
                            <CloseIcon className="cls-1" height="18" width="18" />
                        </div>
                        <div className=" ml-3 mr-3 mb-5">
                            <audio
                                style={{ width: 400 }}
                                ref={a => {
                                    this.audio = a;
                                }}>
                                <p>Audio stream not available. </p>
                            </audio>
                            <div className="text-modal-new-post ">
                                {Translate('uploadAudio', 'es')}
                            </div>
                            <div className="row centerItems centerContent">
                                {!recording &&
                                    <div onClick={e => { this.startRecording(e) }} className="modal-post-audio-contanier play-audio">
                                      
                                        <AudioIcon  className="modal-audio-post-audio-play"/>
                                    </div>
                                }
                                {recording &&
                                    <div className="parent-width row centerContent centerItems">
                                        <div onClick={e => { this.stopRecording(e) }} className="modal-post-audio-contanier stop-audio">
                                            <div className="modal-audio-post-audio-stop" alt="" />
                                        </div>
                                        <div className='text-time-audio'>60seg.</div>
                                        <div name='myProgress' id="progress-bar-audio">
                                            <div name='myBar' id="bar-audio">
                                                <div name='label' id="text-bar-audio">{initialTime}seg.</div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {audio !== '' &&
                                    <div className="column centerContent">
                                        <button className="btn btn-inactive p-2" onClick={() => this.setState({ audio: '' })}>Cancelar</button>
                                        <div className="ml-2 mr-2"></div>
                                        <button className="btn btn-purple p-2" onClick={(e) => this.sendAudioToPost(e)}>Guardar</button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        return (<div></div>)
    }

}
export default ModalTagFriend;